module.exports = __webpack_public_path__ + "img/login_icon.da2d2929.png";